module.exports = __webpack_public_path__ + "static/media/lovely.700a2c2c.png";